import { createFileRoute, Outlet } from "@tanstack/react-router";

// Pathless layout for the /barcode-guides namespace. The index lives in
// barcode-guides.index.tsx; individual articles live in
// barcode-guides.<slug>.tsx. Nothing wraps the children here visually —
// each leaf already renders ToolLayout via GuideLayout — but the parent
// file is required so flat file-based routing nests correctly.
export const Route = createFileRoute("/barcode-guides")({
  component: () => <Outlet />,
});
